module.exports = __webpack_public_path__ + "static/mace_of_smiting-d7825fa1ece6b6d84d4b46240bccdbbc.jpeg";